/* eslint-disable camelcase */
import React, { useEffect, useMemo, useRef } from 'react';
import {
  withStyles, FormControl, FormLabel, FormGroup,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import styles from '~/pages/Quality/styles';
import {
  getSieveOpenings,
  addSieveOpening,
  setSieveOpeningValue,
  resetSieveOpenings,
  updateSieveOpenings,
} from '~/store/quality/actions';
import PF2MDataTable from '~/components/PF2MDataTable';

const SieveTab = ({ classes }) => {
  const sieveOpenings = useSelector(state => state.quality.sieveOpenings);
  const tableData = useMemo(() => sieveOpenings
    .filter(so => so.active), [sieveOpenings]);
  const dispatch = useDispatch();
  const { t: translate } = useTranslation();

  useEffect(() => {
    async function fetchData() {
      dispatch(getSieveOpenings());
    }
    fetchData();
  }, [dispatch]);

  const columns = [
    {
      field: 'name',
      title: translate('common:SieveOpening'),
      width: '100%',
      validate: item => Boolean(item.name),
    },
    {
      field: 'active',
      title: translate('common:Status'),
      customType: 'boolean',
    },
  ];

  return (
    <div className={classes.tabContainer}>
      <PF2MDataTable
        title={translate('common:ParticleSieveOpenings')}
        onDiscard={() => dispatch(resetSieveOpenings())}
        onChange={(newData) => {
          newData.forEach((row) => {
            dispatch(setSieveOpeningValue(row));
          });
        }}
        onDelete={(items) => {
          items.forEach((item) => {
            dispatch(setSieveOpeningValue({ ...item, active: false }));
          });
        }}
        onAdd={newData => dispatch(addSieveOpening(newData))}
        onApply={() => dispatch(updateSieveOpenings(sieveOpenings))}
        options={{ selection: true, showTitle: true }}
        data={tableData}
        columns={columns}
      />
    </div>
  );
};

SieveTab.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SieveTab);
